export { ClaimsNotificationWidget } from './ClaimsNotificationWidget';
